import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "component-home-title" }




export default /*#__PURE__*/_defineComponent({
  props: {
  title: String,
  icon: String,
},
  setup(__props) {

const props = __props



const map = {
  notice: "icon-home-notice.png",
  calendar: "icon-home-calendar.png",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: "icon",
      style: _normalizeStyle({
        backgroundImage: `url(
          https://static.web.sdo.com/mxd/pic/wiki/${map[props.icon]}
        )`,
      })
    }, null, 4),
    _createElementVNode("h2", null, _toDisplayString(props.title), 1)
  ]))
}
}

})